import { Outlet } from 'react-router-dom'

import { RoleGuard } from '@/components/role-guard'
import { isProductionBuild } from '@/utils/environment'

import { LEGACY_RESERVATIONS_BOOKINGS_PATH } from './reservations.constants'

// TODO: remove once the new Reservations pages launch. Until then production only lets
// Administrators in (via the Beta page); everyone else lands on the legacy list.
export const NewReservationsGuard = () =>
  isProductionBuild ? (
    <RoleGuard allowedRoles={['Administrator']} redirectTo={LEGACY_RESERVATIONS_BOOKINGS_PATH} />
  ) : (
    <Outlet />
  )
